import { render } from "./programmesdata.vue?vue&type=template&id=7458c51f&scoped=true"
import script from "./programmesdata.vue?vue&type=script&lang=js"
export * from "./programmesdata.vue?vue&type=script&lang=js"

import "./programmesdata.vue?vue&type=style&index=0&id=7458c51f&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\GCTUSMS\\codev1\\apply_online\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7458c51f"]])

export default __exports__